import { RBC_CELL_TYPE_TREE, LPC_RBC_ASUS_WBC_CELL_TYPE_TREE, type CellTypeMenuTree } from './cellTypeMenuConfig';

export type ProgressDashboardKind = 'rbc' | 'lpc';

const lpcTree: CellTypeMenuTree = LPC_RBC_ASUS_WBC_CELL_TYPE_TREE
  .filter(group => group.name !== 'Unclassified')
  .map(group => ({
    ...group,
    // LPC parents are exact labels too, so give them their own row.
    children: group.children ? [{ name: group.name, label: group.label }, ...group.children] : undefined,
  }));

export const LPC_TARGET_TYPES = lpcTree.flatMap(group =>
  (group.children ?? [group]).map(item => item.name));

export function getLPCDashboardTree(counts: Record<string, number>): CellTypeMenuTree {
  const configured = new Set(LPC_TARGET_TYPES);
  // The backend includes zero-valued legacy types only when cells exist in
  // an earlier workflow state. Preserve these without treating them as labeled.
  const legacy = Object.keys(counts)
    .filter(name => !configured.has(name) && name.toLowerCase() !== 'unclassified')
    .sort()
    .map(name => ({ name, label: name }));
  return legacy.length
    ? [...lpcTree, { name: 'legacy', label: 'Legacy types', clickable: false, children: legacy }]
    : lpcTree;
}

export const PROGRESS_DASHBOARDS = {
  rbc: { title: 'RBC Labelling Progress Tracker', tree: RBC_CELL_TYPE_TREE, keyBy: 'label' },
  lpc: { title: 'LPC Labelling Progress Tracker', tree: lpcTree, keyBy: 'name' },
} as const;
